import styled from 'styled-components'

import { Alert as AntAlert } from 'src/components/Ant'

export const Alert = styled(AntAlert)`
  border-radius: 4px;
  margin: 12px;
`

export const Table = styled.div`
  border-radius: 4px;
  margin: 13px;
`

export const Div = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 4px;
  justify-content: center;
  margin: 13px;
  padding: 60px;
  width: 100%;
`
